import React, {Component} from "react";
import {
    ADD_INSTRUMENT_ROUTE,
    CONTROL_PANEL_ROUTE,
    CONTROL_PANEL_GUARANTEE_REPLACEMENT} from "../../../utils/constants/RoutesConstants";
import GuaranteeReplacement from "./GuaranteeReplacementView";
import {MoveGuaranteeService} from "../../../service/controlPanel/MoveGuaranteeService";
import {amountCalculate} from "../../../utils/formatters/Numbers";
import {Growl} from "primereact/growl";
import {GUARANTEE_EXCESS, GUARANTEE_MARGIN} from "../../../utils/constants/Constants";

export default class GuaranteeReplacementContainer extends Component {
    constructor(props) {
        super(props);

        this.moveGuaranteeService = new MoveGuaranteeService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.updateGuaranteeTotal = this.updateGuaranteeTotal.bind(this);
        this.setGuaranteeS = this.setGuaranteeS.bind(this);
        this.redirectAddInstrument = this.redirectAddInstrument.bind(this);

        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanId: this.props.location.state.folio,
            status: this.props.location.state.status,
            loanAmount: this.props.location.state.loanAmount,
            maturity: this.props.location.state.maturity,
            account: this.props.location.state.borrowerAccount,
            guaranteeAmount: 0,
            marketAmount: 0,
            settlementStatusList: [],
        };

        this.loanData = React.createRef();
        this.guaranteeForChange = React.createRef();
        this.guaranteeInAccount = React.createRef();
    };

    async componentDidMount() {
        await this.loanData.current.getLoan();
        await this.loanData.current.getRestrictionsLoan(this.state.loanId);
        await this.guaranteeInAccount.current.setLoanAmount(this.loanData.current.state.amount);
        await this.guaranteeForChange.current.setLoanAmount(this.loanData.current.state.amount);

        await this.guaranteeForChange.current.getGuarantee();
        await this.guaranteeInAccount.current.getGuaranteeInAccount(this.guaranteeInAccount.current.state.account);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.guaranteeInAccount.current.setState({
            guaranteeAmountInLoanTotal: this.guaranteeForChange.current.state.guaranteeAmountTotal,
            marketAmountInLoanTotal: this.guaranteeForChange.current.state.marketAmountTotal,
        });
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message: message,
        });
    }

    updateGuaranteeTotal(guaranteeAmountTotal, marketAmountTotal) {
        this.setState({
            guaranteeAmount: guaranteeAmountTotal,
            marketAmount: marketAmountTotal,
        });

        this.guaranteeInAccount.current.updateInLoanTotals(guaranteeAmountTotal, marketAmountTotal);

    }

    setGuaranteeS() {
        let arrayGuarantee = [];

        this.guaranteeForChange.current.state.guaranteeList.map(
            (item) => {
                if (item.newTitles && item.newTitles > 0) {
                    arrayGuarantee.push({
                        idEmisora: item.idEmisora,
                        titulos: item.newTitles,
                        idOperacion: GUARANTEE_EXCESS
                    });
                }
                return '';
            });

        this.guaranteeInAccount.current.state.guaranteeList.map(
            (item) => {
                if (item.newTitles && item.newTitles > 0) {
                    arrayGuarantee.push({
                        idEmisora: item.idEmisora,
                        titulos: item.newTitles,
                        idOperacion: GUARANTEE_MARGIN
                    });
                }
                return '';
            });

        if (
            arrayGuarantee.length === 0 ||
            this.loanData.current.state.amount >
            amountCalculate(this.guaranteeInAccount.current.state.guaranteeAmountTotal)
        ) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
        } else {
            this.loading(true);
            this.moveGuaranteeService.setGuaranteeS(
                this.state.loanId,
                this.state.status,
                arrayGuarantee
            ).then(response => {
                this.loading(false);
                if (response.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'Las garantías han sido guardadas exitosamente',
                    });
                }
            });
        }
    }

    redirectAddInstrument() {
        this.props.history.push({
            pathname: ADD_INSTRUMENT_ROUTE,
            state: {
                returnPath: CONTROL_PANEL_GUARANTEE_REPLACEMENT,
                callScreen: "controlPanel",
                addGuarantee: true,
                loanId: this.state.loanId,
                account: this.state.account,
                loanAmount: this.loanData.current.state.amount,
                guaranteeAmount: this.guaranteeInAccount.current.state.guaranteeAmountTotal,
                selectedLoan: this.state.selectedLoan,
                maturity: this.state.maturity,
                status: this.state.status,
            },
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <GuaranteeReplacement
            isLoading={this.state.isLoading}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            handleReturnButton={this.handleReturnButton}
            selectedLoan={this.state.selectedLoan}
            loanId={this.state.loanId}
            loanAmount={this.state.loanAmount}
            maturity={this.state.maturity}
            account={this.state.account}
            guaranteeAmount={this.state.guaranteeAmount}
            loanData={this.loanData}
            guaranteeInAccount={this.guaranteeInAccount}
            guaranteeForChange={this.guaranteeForChange}
            marketAmount={this.state.marketAmount}
            updateGuaranteeTotal={this.updateGuaranteeTotal}
            setGuaranteeS={this.setGuaranteeS}
            redirectAddInstrument={this.redirectAddInstrument}
        />

    }
};